import type {
  Pagination,
  StreamInfo,
} from "../../../aysa_api/shared/v1/pagination.types";
import { Reader, Writer } from "protobufjs/minimal";
import type { Long } from "protoc-gen-ts";

export const createBasePagination = (): Pagination => {
  return {
    offset: 0,
    limit: 0,
  };
};

export const decodePagination = (
  reader: Reader,
  length: number
): Pagination => {
  const end = reader.pos + length;
  const message = createBasePagination();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.offset = (reader.int64() as Long).toNumber();

        break;
      case 2:
        message.limit = (reader.int64() as Long).toNumber();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodePagination = (
  writer: Writer,
  message: Pagination
): Writer => {
  writer.uint32(8).int64(message.offset);
  writer.uint32(16).int64(message.limit);

  return writer;
};

export const createBaseStreamInfo = (): StreamInfo => {
  return {
    total: 0,
  };
};

export const decodeStreamInfo = (
  reader: Reader,
  length: number
): StreamInfo => {
  const end = reader.pos + length;
  const message = createBaseStreamInfo();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.total = (reader.int64() as Long).toNumber();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeStreamInfo = (
  writer: Writer,
  message: StreamInfo
): Writer => {
  writer.uint32(8).int64(message.total);

  return writer;
};
